import { render, staticRenderFns } from "./OrganisationType.vue?vue&type=template&id=42578c9a&"
import script from "./OrganisationType.vue?vue&type=script&lang=js&"
export * from "./OrganisationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports